import styled from 'styled-components/macro'
import { StandardButton } from 'src/components/Reusable/Buttons/StandardButton'

export const DocumentDeleteButton = styled(StandardButton)`
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  svg {
    width: 18px;
    height: 18px;
  }
`
